import React from "react";
import { FiClock, FiSearch, FiX } from "react-icons/fi";

export default function RechercheInitialState({
  recentSearches = [],
  onRecent,
  onClearRecent,
}) {
  return (
    <div className="rounded-[2rem] border border-dashed border-slate-300 bg-white px-6 py-12 text-center shadow-sm dark:border-slate-700 dark:bg-slate-950">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-[#1277B9]/10 text-[#1277B9] dark:bg-[#1277B9]/20 dark:text-sky-300">
        <FiSearch className="h-7 w-7" />
      </div>

      <h2 className="mt-5 text-xl font-bold text-slate-950 dark:text-white">
        Lancez une recherche
      </h2>

      <p className="mx-auto mt-2 max-w-xl text-sm leading-7 text-slate-600 dark:text-slate-300">
        Saisissez un mot-clé pour retrouver rapidement une page, une actualité,
        un événement ou un service municipal.
      </p>

      {recentSearches.length > 0 && (
        <div className="mx-auto mt-7 max-w-2xl">
          <div className="mb-3 flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
            <FiClock className="h-4 w-4" />
            Recherches récentes
          </div>

          <div className="flex flex-wrap justify-center gap-2">
            {recentSearches.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => onRecent(item)}
                className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 transition hover:border-[#1277B9]/50 hover:bg-sky-50 hover:text-[#1277B9] dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:hover:bg-slate-900"
              >
                {item}
              </button>
            ))}
          </div>

          <button
            type="button"
            onClick={onClearRecent}
            className="mt-4 inline-flex items-center gap-2 text-xs font-bold text-slate-400 transition hover:text-red-600"
          >
            <FiX className="h-3.5 w-3.5" />
            Effacer l’historique
          </button>
        </div>
      )}
    </div>
  );
}